// 요소가 지금 「가려져」 있는가 — 코치마크·어드민 말풍선·ⓘ 팝오버가 같이 쓴다(2026-09-27 말풍선 전수조사).
//
// 요소 중심을 눌렀을 때 실제로 그 요소(또는 자식)가 눌리는지 본다. 아니면 위에 다른 층(모달·드로어·시트·고정 헤더)이
// 있거나 스크롤 상자 밖으로 잘린 것이다. 중심이 화면 밖이면 가려짐으로 본다.
// 코치마크 자신의 층(data-coachmark-layer)과 `ignore` 로 넘긴 요소(열린 말풍선 자신 등)는 무시한다.
// jsdom 처럼 elementFromPoint 가 없으면 「안 가려짐」으로 본다(fail-open).
// 화면 판정에 쓰는 뷰포트 크기 — getBoundingClientRect·elementFromPoint 와 같은 좌표계(2026-09-27 재리뷰 2·3회).
// · 폭은 documentElement.clientWidth — 스크롤바를 뺀 폭이고, 핀치 확대로 innerWidth 가 줄어도 그대로다.
// · 높이는 clientHeight 와 「확대하지 않았을 때의 visualViewport.height」 중 큰 쪽 — 휴대폰 주소창이 스크롤로 접히면
//   clientHeight 는 주소창이 보일 때의 작은 높이에 머물러 화면 아래 56~80px 띠를 「화면 밖」으로 보고 말풍선을 닫았다.
//   visualViewport.height 는 가로 스크롤바를 빼고 접힌 주소창만큼 커진다. 확대 중이면 작아지므로 쓰지 않는다.
//   visualViewport 가 없는 옛 브라우저는 innerHeight(스크롤바 포함)로 대신한다.
// 레이아웃이 없는 환경(jsdom)은 client 값이 0 이라 inner 값이 된다.
export function layoutViewportSize() {
  const de = typeof document !== "undefined" ? document.documentElement : null;
  const win = typeof window !== "undefined" ? window : null;
  const w = (de && de.clientWidth) || (win && win.innerWidth) || 0;
  const vv = win && win.visualViewport;
  const visibleH = vv ? (Math.abs((vv.scale || 1) - 1) < 0.01 ? vv.height || 0 : 0) : (win && win.innerHeight) || 0;
  const h = Math.max((de && de.clientHeight) || 0, visibleH);
  return { width: w, height: h };
}

export function isCovered(el, r, { ignore = null } = {}) {
  if (!el || typeof document === "undefined" || typeof document.elementFromPoint !== "function") return false;
  const cx = r.left + r.width / 2;
  const cy = r.top + r.height / 2;
  const vp = layoutViewportSize();
  if (cx < 0 || cy < 0 || cx > vp.width || cy > vp.height) return true;
  const hit = document.elementFromPoint(cx, cy);
  if (!hit) return false;
  if (el === hit || el.contains(hit)) return false;
  if (typeof hit.closest === "function" && hit.closest("[data-coachmark-layer]")) return false;
  const ignores = Array.isArray(ignore) ? ignore : [ignore];
  if (ignores.some((node) => node && typeof node.contains === "function" && node.contains(hit))) return false;
  return true;
}
